import type { MockServer } from './server.js'

export function routes(server: MockServer) {
  server.get('/home_delivery_dashboard/custom_integrations', function (schema) {
    const integrations = schema
      .all('customIntegration')
      .filter(
        (integration) =>
          integration.attrs.custom_integration_type === 'HOME_DELIVERY' &&
          integration.attrs.enabled === true,
      )

    return {
      data: integrations.models.map((integration) => ({
        type: 'HomeDeliveryDashboardCustomIntegration',
        id: integration.id,
        attributes: {
          ...integration.attrs,
          action_parameters: '',
          parameter_value: null,
          verification_timestamp: null,
          verification_hash: null,
          provet_env: null,
          provet_id: null,
          department_id: null,
        },
      })),
    }
  })
}

export function seeds(server: MockServer) {
  server.create('customIntegration', {
    name: 'Home Delivery Tab Integration',
    custom_integration_type: 'HOME_DELIVERY',
    action: 'TAB',
    enabled: true,
  })
  server.create('customIntegration', {
    name: 'Home Delivery Popup Integration',
    custom_integration_type: 'HOME_DELIVERY',
    action: 'POPUP',
    enabled: true,
  })
  server.create('customIntegration', {
    name: 'Home Delivery Tab Integration 2 (Disabled)',
    custom_integration_type: 'HOME_DELIVERY',
    action: 'TAB',
    enabled: false,
  })
  server.create('customIntegration', {
    name: 'Home Delivery Panel Integration',
    custom_integration_type: 'HOME_DELIVERY',
    action: 'PANEL',
    url: 'https://example.com/home-delivery-panel',
    enabled: true,
  })
}
